import React from "react";

import { Box, IconButton, Typography, styled } from "@mui/material";
import { grey } from "@mui/material/colors";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import MapInfoIcon from "./mapInfo/MapInfoIcon";

const StyledBox = styled(Box)(() => ({
  backgroundColor: "#1b2021",
}));

const StyledIconButton = styled(IconButton)(() => ({
  width: 40,
  height: 40,
  borderRadius: 3,
  pointerEvents: "auto",
}));

const Puller = styled(Box)(() => ({
  width: 30,
  height: 6,
  backgroundColor: grey[500],
  borderRadius: 3,
  position: "absolute",
  top: 4,
  left: "calc(50% - 15px)",
}));

function SidebarMobileHeader({ drawerBleeding, open, setOpen, isTouchDevice }) {
  const toggleOpen = () => setOpen(!open)

  const renderToggle = () => {
    if (isTouchDevice) {
      return undefined
    }

    return (
      <StyledBox sx={{
        visibility: "visible",
        position: "absolute",
        top: -drawerBleeding - 30,
        right: 0,
        display: "flex",
        alignItems: "center",
        height: "30px",
      }}>
        <StyledIconButton onClick={toggleOpen} disableRipple>
          {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
        </StyledIconButton>
      </StyledBox>
    )
  }

  return (
    <>
      {renderToggle()}

      <StyledBox sx={{
        visibility: "visible",
        position: "absolute",
        top: -drawerBleeding,
        right: "0",
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "50px",
        maxHeight: "50px",
      }}>
        {isTouchDevice && <Puller />}
        <Typography
          variant="h1"
          component="h1"
          sx={{
            lineHeight: "1",
            pb: isTouchDevice ? 3 : 2,
            pt: isTouchDevice ? 3 : 2,
            pl: 2,
          }}>
          London High Streets Map Explorer
        </Typography>
        <MapInfoIcon />
      </StyledBox>
    </>
  )
}

export default SidebarMobileHeader;